import React from 'react';
import Layout from '@src/layouts';
import SEO from '@commons/SEO';

import {
  MobileHeaderLayoutA,
  DesktopHeaderLayoutB,
  SliderWithClickableBlocks,
  TechStackWithCategories,
  OpacityScrolledSlider,
  SectionUnderHeaderWithUnderline,
  ContactButtonImageSection,
  NewClientSingleTestimonial,
  SliderWithTextBlocks,
  BlocksRedirectingToResources,
  BlocksInRowsWithOneActive,
  ColoredBlocksWithRedirects,
  CertificatesSection,
} from '@commons/index';

import {
  SEOProps,
  headerProps,
  sliderWithClickableBlocksProps,
  techStackWithCategoriesProps,
  opacityScrolledSliderProps,
  sectionUnderHeaderProps,
  contactButtonImageSectionProps,
  testimonialProps,
  sliderWithTextBlocksProps,
  blocksRedirectingToResourcesProps,
  blocksInRowsWithOneActiveProps,
  coloredBlocksWithRedirectsProps,
} from '@pages-impl/networks/payload';

export default function NetworksPage(props) {
  return (
    <Layout
      newFormat
      subtitleLess
      displayTopBanner={false}
      contactFormTitle="Take a step toward a modern network"
      isContactFormTitleUnderline={false}
      {...props}
    >
      <SEO {...SEOProps} />
      <DesktopHeaderLayoutB {...headerProps} />
      <MobileHeaderLayoutA {...headerProps} />
      <SectionUnderHeaderWithUnderline {...sectionUnderHeaderProps} />
      <SliderWithTextBlocks {...sliderWithTextBlocksProps} />
      <ContactButtonImageSection {...contactButtonImageSectionProps} />
      <BlocksInRowsWithOneActive {...blocksInRowsWithOneActiveProps} />
      <OpacityScrolledSlider {...opacityScrolledSliderProps} />
      <SliderWithClickableBlocks {...sliderWithClickableBlocksProps} />
      <CertificatesSection />
      <NewClientSingleTestimonial {...testimonialProps} />
      <TechStackWithCategories {...techStackWithCategoriesProps} />
      <BlocksRedirectingToResources {...blocksRedirectingToResourcesProps} />
      <ColoredBlocksWithRedirects {...coloredBlocksWithRedirectsProps} />
    </Layout>
  );
}
